type TState =string[];

export default (previousState: TState, action: { type: string, value: any }): any => {

    switch(action.type) {

        case 'INITIALIZE_DATA':
            return ([
                ...action.value
            ]);


        case 'ADD_MAIL':
            return ([
                ...previousState,
                action.value,
            ]);

        case 'DELETE_MAIL':
            return previousState.filter((item: any) => item.email !== action.value.mail);

    }
}
